import { MOCK_JOINED_GROUPS, MOCK_MY_GROUPS, MOCK_DISCOVER_GROUPS } from '@/src/constants/groups/mock-groups';

export enum GroupTab {
	JOINED_GROUPS = 'LABEL_JOINED_GROUPS',
	MY_GROUPS = 'LABEL_MY_GROUPS',
	ALL_GROUPS = 'LABEL_ALL_GROUPS',
}

export const GROUP_TAB_KEYS = [
	GroupTab.JOINED_GROUPS,
	GroupTab.MY_GROUPS,
	GroupTab.ALL_GROUPS,
];


export enum GroupDetailsTab {
	POSTS = 'LABEL_TAB_POSTS',
	MEMBERS = 'LABEL_TAB_MEMBERS',
	EVENTS = 'LABEL_TAB_EVENTS',
	FILES = 'LABEL_TAB_FILES',
	NEWS = 'LABEL_TAB_NEWS',
}

export const GROUP_DETAILS_TAB_KEYS = [
	GroupDetailsTab.POSTS,
	GroupDetailsTab.MEMBERS,
	GroupDetailsTab.EVENTS,
	GroupDetailsTab.FILES,
	GroupDetailsTab.NEWS
];
